<template>
    <div class="sub-setting-array control e-control" :id="name" v-if="config.display" :style="{'width': config.width || '100%'}">
        <label-wrapper :label-settings="config" cId="labelWrapper"></label-wrapper>
        <p v-if="config.message" class="input-info" v-html="ddStoreFilter(config.message)"></p>
        <div class="sub-setting-items">
            <div class="action-area" v-if="!config.hideActions || allowAddItem">
                <div class="show-items-btn" v-if="!config.hideActions">
                    <button v-if="!value || value.length > 0" type="button" @click="expandItems()">
                        <span v-if="showItems" class="expander-toggle">
                            <span class="sr-only">(hide)</span>
                            <span class="e-icons e-collapse"></span>
                        </span>
                        <span v-if="!showItems" class="expander-toggle">
                            <span class="sr-only">(show)</span>
                            <span class="e-icons e-expand"></span>
                        </span>
                    </button>
                    <span v-if="!value || value.length === 0">
                        No {{config.itemConfig.itemLabel || 'items'}}.<span v-if="allowAddItem"> Click "Add" to add one.</span>
                    </span>
                    <span v-else-if="config.itemConfig.itemType === 'object'">
                        <button type="button" @click="expandItems()">
                           {{value.length}} {{value.length === 1 ? 'item' : 'items'}}:
                        </button>
                        <button v-if="value.length > 0" class="item-summary-label" type="button" @click="toggleExpand(0); expandItems(true)">
                            {{config.itemConfig.primaryLabel ? config.itemConfig.primaryLabel + ' 1' : getLabelByPath(value[0], config.itemConfig.primaryKey)}}
                        </button>
                        <span v-if="value.length > 1">
                            <span v-if="value.length === 2"> and </span>
                            <span v-if="value.length > 2">, </span>
                            <button class="item-summary-label" type="button" @click="toggleExpand(1); expandItems(true)">
                                {{config.itemConfig.primaryLabel ? config.itemConfig.primaryLabel + ' 2' : getLabelByPath(value[1], config.itemConfig.primaryKey)}}
                            </button>
                        </span>
                        <span v-if="value.length > 2"> and
                            <button type="button" @click="expandItems()">{{value.length - 2}} more </button>
                        </span>
                    </span>
                    <span v-else>
<!--                        {{ value.length }} {{ config.itemConfig.primaryLabel || config.itemConfig.primaryKey }}-->
                        <button type="button" @click="expandItems()">
                           {{value.length}} {{value.length === 1 ? 'item' : 'items'}}:
                        </button>

                        <button v-if="value.length > 0" class="item-summary-label" type="button" @click="toggleExpand(0); expandItems(true)">
                            {{config.itemConfig.primaryLabel ? config.itemConfig.primaryLabel + ' 1' : 'Item 1'}}
                        </button>

                        <span v-if="value.length > 1">
                            <span v-if="value.length === 2"> and </span>
                            <span v-if="value.length > 2">, </span>
                            <button class="item-summary-label" type="button" @click="toggleExpand(1); expandItems(true)">
                                {{config.itemConfig.primaryLabel ? config.itemConfig.primaryLabel + ' 2' : 'Item 2'}}
                            </button>
                        </span>

                        <span v-if="value.length > 2"> and
                            <button type="button" @click="expandItems()">{{value.length - 2}} more </button>
                        </span>

                    </span>
                </div>
                <ejs-button isPrimary="true" type="button" :cssClass="'add-item-btn'" v-on:click="() => { if (onValidateValue(true)) { addItem() } }" :disabled="config.disabled" v-if="allowAddItem">Add</ejs-button>
            </div>
            <div v-if="showItems" class="items-list-container" :class="{'is-dragging': config.allowDragAndDrop && dragIndex !== false }">
                <ul class="object-item-headers" v-if="!config.hideHeaders" :class="{ 'item-opened': anyExpanded }">
                    <li v-if="!value || value.length === 0">No {{config.itemConfig.itemLabel || 'items'}}.<span v-if="allowAddItem"> Click "Add {{config.label}}" to add one.</span></li>
                    <li v-for="(option,index) in value"
                        :key="index"
                        :class="{'object-item-header': true, 'object-item-header-even': index%2, 'dragged-item': dragIndex === index}"
                        :draggable="config.allowDragAndDrop && dragIndex === index"
                        @dragstart="onDragstart($event, option, index)"
                        @dragend="onDragend($event, option, index)"
                    >
                        <div class="item-action-area">
                            <div v-if="config.allowDragAndDrop" @mousedown="dragIndex = index;" @mouseup="dragIndex = false;" :id="'drag_handle_' + index" class="drag-drop-handle"><span class="e-drag-and-drop"><i class="fa-solid fa-grip-dots-vertical"></i></span></div>
                            <div :id="index + '_drop_zone'" class="drop-zone" :class="{'first-drop-zone': index === 0}" @drop="onDrop($event, option, index)" @dragover="onDragover($event, option)" @dragleave="onDragleave"><div class="drop-indicator">{{}}</div></div>
                            <button class="object-item-toggle" @click="toggleExpand(index)">
                                <span v-if="expanded[index]" class="expander-toggle">
                                    <span class="sr-only">(hide)</span>
                                    <span class="e-icons e-collapse"></span>
                                </span>
                                <span v-if="!expanded[index]" class="expander-toggle">
                                    <span class="sr-only">(show)</span>
                                    <span class="e-icons e-expand"></span>
                                </span>
                                <span v-if="config.itemConfig.itemType === 'object'" v-html="config.itemConfig.primaryLabel ? config.itemConfig.primaryLabel + ' ' + (index + 1) : getLabelByPath(option, config.itemConfig.primaryKey)"  class="expander-title">
                                </span>
                                <span v-else v-html="(config.itemConfig.primaryLabel || config.itemConfig.primaryKey) + ' ' + (index + 1)" class="expander-title">
                                </span>
                                <span v-if="config.itemConfig.itemType === 'object'" v-html="getLabelByPath(option, config.itemConfig.secondaryKey)"  class="expander-description">
                                </span>
                                <span v-else v-html="(config.itemConfig.secondaryKey) + ' ' + (index + 1)" class="expander-description">
                                </span>
                                <span v-if="config.itemConfig.itemType === 'object'" v-html="getLabelByPath(option, config.itemConfig.idKey)" class="expander-id">
                                </span>
                            </button>
                            <ejs-dropdownbutton v-if="enableItemActions" :disabled="config.disabled" :items="allowedActions" cssClass="e-caret-hide editor-item-action" v-on:select="itemSelect($event, index, value)">
                                <span class="e-icons e-menu"></span><span class="sr-only">More</span>
                            </ejs-dropdownbutton>
                            <div v-if="index === value.length - 1" :id="index + '_drop_zone'" class="drop-zone last-drop-zone" @drop="onDrop($event, option, index)" @dragover="onDragover($event, option, true)" @dragleave="onDragleave"><div class="drop-indicator">{{}}</div></div>
                        </div>
                    </li>
                </ul>
                <ul class="object-item-contents" :class="{ 'item-opened': anyExpanded }">
                    <li v-for="(option,index) in value" :key="index" class="object-item-container" :class="{ 'item-opened': expanded[index] }">
                        <div class="item-action-area" v-if="!config.hideHeaders">
                            <button class="object-item-toggle back-toggle" v-if="!config.expandAll" @click="() => { if (onValidateValue(true)) { toggleExpand(index) } }">
                                <span v-if="expanded[index]" class="expander-toggle">
                                    <span class="sr-only">(hide)</span>
                                    <span class="e-icons e-slide-close"></span>
                                </span>
                                <span v-if="config.itemConfig.itemType === 'object' && config.itemConfig.primaryKey" v-html="getLabelByPath(option, config.itemConfig.primaryKey)" class="expander-title">
                                </span>
                                <span v-else v-html="(config.itemConfig.primaryLabel || config.itemConfig.primaryKey) + ' ' + (index + 1)" class="expander-title">
                                </span>
                            </button>
                            <ejs-dropdownbutton v-if="enableItemActions" :disabled="config.disabled" :items="allowedActions" cssClass="e-caret-hide editor-item-action" v-on:select="itemSelect($event, index, value)">
                                <span class="e-icons e-menu"></span><span class="sr-only">More</span>
                            </ejs-dropdownbutton>
                        </div>
                        <div v-if="expanded[index]" class="object-item-content">
                            <div v-if="config.itemConfig.itemType === 'object'">
                                <div v-if="accordionMenuSettings()">
                                    <accordion-menu :c-id="'accordionMenu__' + library.getUniqueID()" prop-default-opened-item="0" :prop-i-config="accordionMenuSettings()" :use-parent-store-id="true">
                                        <template v-for="(slot,slotIndex) in accordionMenuSettings().menuItems" :key="slotIndex" v-slot:[slot.slotName]>
                                            <div v-for="(itemConfig,key) in filteredKeys(option, slot.slotId)" :key="key">
                                                <div v-if="!itemConfig.isHeavyControl || (itemConfig.isHeavyControl && showHeavyControls[index])">
                                                    <control
                                                        :name="name + '_' + index + '_' + key"
                                                        :ref="name + '_' + index + '_' + key"
                                                        :prop-config="itemConfig"
                                                        :value="value[index][key]"
                                                        :disabled="config.disabled"
                                                        :index="index"
                                                        :values-map="valuesMap"
                                                        @update:value="value[index][key] = $event; setValueLabel($event, itemConfig, option, key)"
                                                        :recordId="recordId"
                                                    ></control>
                                                </div>
                                            </div>
                                        </template>
                                    </accordion-menu>
                                </div>
                                <div v-else>
                                    <div v-for="(itemConfig,key) in filteredKeys(option)" :key="key">
                                        <div v-if="!itemConfig.isHeavyControl || (itemConfig.isHeavyControl && showHeavyControls[index])">
                                            <control
                                                :name="name + '_' + index + '_' + key"
                                                :ref="name + '_' + index + '_' + key"
                                                :prop-config="itemConfig"
                                                :value="value[index][key]"
                                                :disabled="config.disabled"
                                                :index="index"
                                                :values-map="valuesMap"
                                                @update:value="value[index][key] = $event; setValueLabel($event, itemConfig, option, key)"
                                                :recordId="recordId"
                                            ></control>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div v-if="!config.itemConfig.isHeavyControl || (config.itemConfig.isHeavyControl && showHeavyControls[index])">
                                    <control
                                        :name="name + '_' + index"
                                        :ref="name + '_' + index"
                                        :prop-config="config.itemConfig"
                                        :index="index"
                                        :value="value[index]"
                                        :disabled="config.disabled"
                                        @update:value="value[index] = $event"
                                        :values-map="valuesMap"
                                        :recordId="recordId"
                                    ></control>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { library } from "@common/library/library";
import { controlMixins } from "./controlMixins.js";

let editorSettings = {};
const controlComponent = defineAsyncComponent(() => import('@common/control/control.vue'));
const accordionMenu = defineAsyncComponent(() => import('@common/accordionMenu/accordionMenu.vue'));

export const arrayOfObjectsComponent = {
    editorSettings: editorSettings,
    data() {
        return {
            expanded: [],
            showHeavyControls: [],
            heavyControls: ['logic', 'logiceditor', 'pdf', 'iconpicker'],
            anyExpanded: false,
            showItems: false,
            accordionSettings: false,
            actionsButton: {
                type: 'dropdownbutton',
                fields: { text: 'label', value: 'key' },
                onselect: 'switchType',
                label: '<span class="e-icons e-menu"></span><span class="sr-only">More</span>',
                items: [
                    { text: 'Delete Item', value: 'delete' },
                    { text: 'Move Up', value: 'up' },
                    { text: 'Move Down', value: 'down' },
                ]
            },
            itemActions: [
                { text: 'Move Up', value: 'up' },
                { text: 'Move Down', value: 'down' },
                { text: 'Copy Item', value: 'copy' },
                { text: 'Delete Item', value: 'delete' },
                { text: 'Delete All Items', value: 'deleteAll' },
            ],
            dragIndex: false,
            onValidateValueTimeout: false,
            showHeavyControlsTimeoutID: false
        };
    },
    mixins: [controlMixins],
    components: {
        control: controlComponent,
        "accordion-menu": accordionMenu,
        "ejs-button": defineAsyncComponent(() => import('@common/syncfusion/button')),
        "ejs-dropdownbutton": defineAsyncComponent(() => import('@common/syncfusion/dropdownButton'))
    },
    watch: {
        value: {
            handler(value) {
                this.onValidateValue(false, true);
                if (this.$parent && this.$parent.$attrs) {
                    this.$parent.$emit('update:value', value);
                }
            },
            deep: true
        },
        items: {
            handler(value) {
                if (this.$parent && this.$parent.$attrs) {
                    this.$parent.$emit('update:items', value);
                }
            },
            deep: true
        }
    },
    computed: {
        allowedActions() {
            let output = [];
            let actions = this.itemActions;
            let iPermissions = library.getByPath(this.config, 'itemConfig.permissions');
            if (iPermissions) {
                if (iPermissions.canDelete) output.push(actions[0]); // NOSONAR
                if (iPermissions.canMove && !this.config.allowDragAndDrop) {
                    output.push(actions[1]); // NOSONAR
                    output.push(actions[2]); // NOSONAR
                }
                if (iPermissions.canDelete) output.push(actions[3]); // NOSONAR
            }
            for (let i in output) {
                if (output[i].value !== 'delete' && output[i].value !== 'deleteAll') output[i].disabled = !this.config.valid;
            }
            return output;
        },
        allowAddItem() {
            return library.getByPath(this.config, 'itemConfig.permissions.allowAddItem');
        },
        enableItemActions() {
            return Array.isArray(this.allowedActions) && this.allowedActions.length;
        }
    },
    methods: {
        onValidateValue(showError, useTimeout) {
            if (useTimeout) {
                if (this.onValidateValueTimeout) clearTimeout(this.onValidateValueTimeout);
                this.onValidateValueTimeout = setTimeout(() => {
                    this.onValidateValue(showError);
                }, 500);
                return true;
            }
            let valid = true;
            let validationErrors = [];
            if (this.$refs) {
                for (let i in this.$refs) {
                    if (typeof this.$refs?.[i]?.[0]?.config !== 'undefined' && !this.$refs[i][0].config.valid) {
                        valid = false;
                        if (Array.isArray(this.$refs[i][0].config.validationErrors)) {
                            validationErrors = [...validationErrors, ...this.$refs[i][0].config.validationErrors];
                        }
                    }
                }
            }
            this.config.valid = valid;
            this.config.validationErrors = library.cloneObj(validationErrors);
            if (showError && !valid && validationErrors.length) {
                library.showDialog(this.config.validationErrors.join('<br/>'), false, false, { showAsAlert: true });
            }
            return valid;
        },
        onDragstart(event, item, index) {
            item.index = index;
            event.dataTransfer.setData("application/json", JSON.stringify(item));
            event.dataTransfer.effectAllowed = "move";
        },
        onDragend(event, item) {
            this.dragIndex = false;
        },
        onDragover(event, item, lastItem) {
            event.preventDefault();
            event.target.classList.add('hovered');
            event.dataTransfer.dropEffect = "move";
        },
        onDragleave(event) {
            event.preventDefault();
            event.target.classList.remove('hovered');
        },
        onDrop(event, item, index) {
            event.preventDefault();
            event.target.classList.remove('hovered');
            let movedItem = event.dataTransfer.getData("application/json");
            if (library.isJson(movedItem)) movedItem = JSON.parse(movedItem);
            let moveFromIndex = movedItem.index;
            let isLast = false;
            if (Array.isArray(this.value) && index === this.value.length - 1) isLast = true;
            let moveToIndex = index < movedItem.index || isLast ? index : index - 1;
            this.value = library.moveArrayItem(this.value, moveFromIndex, moveToIndex);
            this.dragIndex = false;
        },
        // itemIsShown(option, key) {
        //     let result = true;
        //     if (this.config && this.config.itemConfig && this.config.itemConfig.logic && this.config.itemConfig.logic[key]) {
        //         result = library.logicParser.call(option, this.config.itemConfig.logic[key]);
        //     }
        //     return result;
        // },
        getLabelByPath(obj, path) {
            path = obj[path + '_displayAs'] ? path + '_displayAs' : path;
            return library.getByPath(obj, path);
        },
        accordionMenuSettings() {
            if (this.config.itemConfig.isUseAccordionMenu !== true || typeof this.config.itemConfig.accordionMenuSlots !== 'object') {
                return null;
            }
            if (typeof this.accordionSettings === 'object') {
                return this.accordionSettings;
            }
            this.accordionSettings = { menuItems: [] };
            this.config.itemConfig.accordionMenuSlots.forEach((slot) => {
                this.accordionSettings.menuItems.push({
                    header: slot.label,
                    useSlot: true,
                    slotName: library.getUniqueID(),
                    slotId: slot.id
                });
            });
            return this.accordionSettings;
        },
        filteredKeys(option, accordionMenuSlotId) {
            let output = {};
            let keys = Object.keys(this.config.itemConfig.keys);
            keys.forEach((key) => {
                let add = true;
                let hiddenKeys = Array.isArray(this.config?.itemConfig?.hiddenKeys) ? this.config.itemConfig.hiddenKeys : [];
                if (hiddenKeys.indexOf(key) !== -1) add = false;
                // Logic overrides hiddenKeys config prop
                if (this.config.itemConfig.logic && this.config.itemConfig.logic[key]) {
                    add = library.logicParser.call(option, this.config.itemConfig.logic[key]);
                }
                if (accordionMenuSlotId && accordionMenuSlotId !== this.config.itemConfig.keys[key].accordionMenuSlotId) {
                    add = false;
                }
                if (add) {
                    output[key] = this.config.itemConfig.keys[key];
                    if (this.heavyControls.indexOf(this.config.itemConfig.keys[key].type) !== -1) output[key].isHeavyControl = true;
                }
            });
            return library.cloneObj(output);
        },
        toggleExpand(index) {
            if (this.config.expandAll) return;
            let toggleState = this.expanded[index] !== true;
            this.collapseAllItems();
            this.expanded[index] = toggleState;
            this.showHeavyControlsTimeout();
            this.anyExpanded = toggleState;
            // TODO create a better solution than this
            this.$forceUpdate();
        },
        collapseAllItems() {
            for (let index in this.expanded) {
                if (index === 'length') continue;
                this.expanded[index] = false;
            }
            this.anyExpanded = false;
        },
        itemSelect(event, index, items) {
            if (!this.items) this.items = this.value;
            if (event.item.value === 'copy') {
                library.showToast('Item copied!');
                let newItem = library.cloneObj(items[index]);
                if (typeof this.config?.itemConfig?.copyItem === 'object') {
                    for (let i in this.config.itemConfig.copyItem) {
                        newItem[i] = library.cloneObj(this.config.itemConfig.copyItem[i]);
                    }
                }
                // items.push(newItem);
                // this.items = items;
                this.value.push(newItem);
            } else if (event.item.value === 'delete') {
                library.showDialog("Are you sure you want to delete this item, and all of it's sub items and properties.", () => {
                    // items.splice(index, 1);
                    // this.items = items;
                    this.value.splice(index, 1);
                    this.collapseAllItems();
                });
            } else if (event.item.value === 'deleteAll') {
                library.showDialog("Are you sure you want to delete all items, and all of it's sub items and properties.", () => {
                    // items.splice(0, items.length);
                    // this.items = items;
                    this.value.splice(0, items.length);
                    this.collapseAllItems();
                });
            } else if (event.item.value === 'up') {
                if (index - 1 >= 0) {
                    // this.items = library.moveArrayItem(this.items, index, index - 1);
                    this.value = library.moveArrayItem(this.value, index, index - 1);
                }
            } else if (event.item.value === 'down' && index + 1 < this.items.length) {
                // this.items = library.moveArrayItem(this.items, index, index + 1);
                this.value = library.moveArrayItem(this.value, index, index + 1);
            }
        },
        expandItems(stayOpen) {
            if (stayOpen) {
                this.showItems = true;
            } else {
                this.showItems = !this.showItems;
                if (this.value.length === 1) {
                    setTimeout(() => {
                        this.expanded[0] = true;
                        this.showHeavyControlsTimeout();
                        this.anyExpanded = true;
                        this.$forceUpdate();
                    }, 100); // NOSONAR
                }
            }
        },
        addItem() {
            if (this.config.itemConfig.newItem) {
                let newItem = library.cloneObj(this.config.itemConfig.newItem);
                let tmp = library.cloneObj(this.value || this.items || []);
                tmp.push(newItem);
                this.items = tmp;
                this.value = tmp;
                this.collapseAllItems();
                this.showItems = true;
                this.expanded[this.value.length - 1] = true;
                this.showHeavyControlsTimeout();
                this.anyExpanded = true;
                this.$forceUpdate();
            }
        },
        showHeavyControlsTimeout() {
            // show heavy controls after animation is finish
            if (this.showHeavyControlsTimeoutID) clearTimeout(this.showHeavyControlsTimeoutID);
            this.showHeavyControlsTimeoutID = setTimeout(() => {
                this.showHeavyControls = library.cloneObj(this.expanded);
            }, 500);
        },
        setValueLabel(value, itemConfig, option, key) {
            const { displayAs: valueLabel, value: valueField } = itemConfig?.fields || {};
            const items = this.controls?.[itemConfig.name]?.items || [];
            const valueRecord = items.find((obj) => obj[valueField] === value);

            if (valueLabel && valueRecord) {
                option[key + '_displayAs'] = valueRecord[valueLabel];
            }
        }
    },
    mounted() {
        if (this.config && this.config.hideActions) {
            this.showItems = true;
        }
        if (this.config?.expandAll) {
            if (Array.isArray(this.value)) {
                this.value.forEach((_val, index) => {
                    this.expanded[index] = true;
                });
            }
            this.showItems = true;
            this.anyExpanded = true;
            this.config.hideActions = true;
        }
    },
    updated() {
        if (this.config && this.config.hideActions) {
            this.showItems = true;
        }
        if (this.$parent && this.$parent.component && typeof this.$parent.component.updateLockedControls === 'function') {
            this.$parent.component.updateLockedControls(false, true);
        }
        if (this.config?.expandAll) {
            if (Array.isArray(this.value)) {
                this.value.forEach((_val, index) => {
                    this.expanded[index] = true;
                });
            }
            this.anyExpanded = true;
            this.showItems = true;
            this.config.hideActions = true;
        }
    }
};

export default arrayOfObjectsComponent;
</script>

<style lang="css">
.sub-setting-array {
    width: 100%;
}

.sub-setting-array .sub-setting-items {
    border: 1px solid rgba(0, 0, 0, 0.24);
    border-radius: 4px;
}

.sub-setting-array .sub-setting-items ul {
    margin: 0;
    padding: 0;
    list-style: none;
}

.sub-setting-array .sub-setting-items ul li + li:not(.checkbox-wrapper) {
    border-top: 2px solid #8894e1;
}

.sub-setting-array .sub-setting-items .sub-setting-items ul li {
    width: 100%;
}
.sub-setting-array .item-action-area {
    display: flex;
}
.sub-setting-array .object-item-toggle {
    flex-grow: 9;
    color: #fff;
    background: #384dd0;
    padding: 8px 12px;
    text-align: left;
    border: 0 none;
}
.object-item-toggle.item-opened {
    background: #566bf0;
    padding-left: 20px;
}
.object-item-toggle.back-toggle {
    float: none;
}
.sub-setting-array .object-item-content {
    padding: 8px;
    border: 1px solid #384dd0;
}
.object-item-content:not(:has(.control)) {
    display: none;
}
.sub-setting-array .e-expand:before {
    content: '\e653' !important;
}
.sub-setting-array .e-collapse:before {
    content: '\e652' !important;
}
.sub-setting-array .e-menu:before {
    content:'\e984' !important;
}
.e-slide-close:before {
    content: '\e654' !important;
}
.sub-setting-array .expander-toggle {
    margin-right: 5px;
}
.sub-setting-array .expander-toggle {
    position: relative;

}
.sub-setting-array .expander-toggle .e-collapse {
    top: 2px;
    left: -2px;
}
.sub-setting-array .expander-toggle .e-expand {
    top: 2px;
}
.show-items-btn {
    border: 0 none;
    background: transparent;
    cursor: pointer;
    padding: 3px 10px;
    border-radius: 20px;
}
.show-items-btn:hover {
    background: rgba(0,0,0, 0.06);
}
.show-items-btn button {
    border: 0 none;
    background: transparent;
    cursor: pointer;
}
.show-items-btn .expander-toggle {
    top: 3px;
    margin-left: 5px;
}
.sub-setting-array .editor-item-action {
    padding: 0;
    border: 1px solid #ccc;
}
.sub-setting-array .action-area {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;
    padding: 6px;
    min-height: 40px;
}
.sub-setting-array .action-area .add-item-btn {
    position: relative;
    float: right;
}
.sub-setting-array .action-area .item-summary-label {
    border-bottom: 2px solid #b3d278;
    padding: 2px 1px;
    margin-right: 3px;
    display: inline-block;
}
.items-list-container {
    overflow: hidden;
    position: relative;
    width: 100%;
}
.object-item-container {
    position: relative;
    transition: right .4s ease-in;
    right: -100%;
    height: 0;
}
.object-item-container.item-opened {
    transition: right .4s ease-out;
    right: 0;
    height: auto;
}
.object-item-contents:not(.item-opened) .editor-item-action, .object-item-headers.item-opened .editor-item-action {
    opacity: 0;
    width: 0;
    transition: none;
}
.object-item-contents {
    width: 100%;
}
.object-item-contents:not(.item-opened) {
    height: 0;
    overflow: visible;
    top: 0;
    position: absolute;
}
.object-item-contents.item-opened .editor-item-action, .object-item-headers .editor-item-action  {
    opacity: 1;
    width: 22px;
    transition: .2s .6s;
}
.object-item-headers {
    position: relative;
    transition: left .4s ease-in;
    left: 0;
}
.object-item-headers.item-opened {
    transition: left .4s ease-out;
    left: -100%;
    height: 0;
    overflow: visible;
}
.object-item-toggle {
    display: flex;
}
</style>

<style scoped>
:deep(.object-item-header) {
    position: relative;
}
/* Drag & Drop Classes */
:deep(.drag-drop-handle) {
    width: 20px;
    height: auto;
    margin: 1px;
    opacity: 0.4;
    cursor: grab;
    position: relative;
    left: -3px;
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    transition: opacity .3s ease-in-out;
}
:deep(.fa-grip-dots-vertical) {
    font-size: 1.2rem;
}
:deep(.object-item-header:hover .drag-drop-handle) {
    opacity: 1;
}
:deep(.object-item-header:hover .drag-drop-handle:hover) {
    opacity: 1;
}
:deep(.dragged-item .drag-drop-handle) {
    cursor: grabbing;
}
:deep(.object-item-header.dragged-item) {
    background: #eff9fc;
    border: 2px dashed #0a9bc0 !important;
    padding-left: 2px;
}
:deep(.drop-zone) {
    position: absolute;
    width: 100%;
    height: 12px;
    left: 0;
    top: -7px;
    display: none;
}
:deep(.drop-zone.first-drop-zone) {
    top: 0;
    bottom: 0;
}
:deep(.drop-zone.last-drop-zone) {
    top: unset;
    bottom: 0;
}
:deep(.drop-indicator) {
    height: 4px;
    background: #3495ad;
    position: relative;
    top:4px;
    z-index: 1000;
    border-radius: 0 2px 2px 0;
    display: none;
    pointer-events: none; /* used to prevent dragleave when over indicator */
}
:deep(.drop-zone.first-drop-zone .drop-indicator) {
    top: 0;
}
:deep(.drop-zone.last-drop-zone .drop-indicator) {
    top: 8px;
}
/* :hover pseudo class does not work when holding mouse click down */
:deep(.drop-zone.hovered .drop-indicator) {
    display: block;
}
:deep(.is-dragging .drop-zone) {
    display: block;
}
/* Prevent display of the drop-zone of the item being dragged, and it's next sibling's drop-zone */
:deep(.is-dragging .dragged-item .drop-zone),
:deep(.is-dragging .dragged-item + .object-item-header .drop-zone:not(.last-drop-zone)) {
    display: none;
}
:deep(.is-dragging .object-item-header) {
    overflow: inherit;
}
:deep(.object-item-headers.is-dragging) {
    position: relative !important;
    overflow: inherit;
    overflow-x: visible !important;
}
:deep(.expander-description) {
    margin: 0 10px;
    text-align: left;
    width: 30%;
    max-width: 30%;
}
:deep(.expander-title) {
    width: 100%;
}
:deep(.expander-id) {
    width: 100px;
    text-align: center;
}
</style>
